"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RateOptionEdit = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const useForm_1 = require("../../../../hooks/useForm");
const classFunctions_1 = require("../../../../utils/classFunctions");
const locale_1 = require("../../../../utils/locale");
const Button_1 = require("../../../Button");
const CheckBox_1 = require("../../../CheckBox");
const Field_1 = require("../../../Form/Field");
const Multilanguage_1 = require("../../../Form/Field/Multilanguage");
const Select_1 = require("../../../Form/Field/Select");
const Textarea_1 = require("../../../Form/Field/Textarea");
const Tabs_1 = require("../../../Tabs");
require("./index.scss");
const className = 'rate-option-edit';
const schema = (0, useForm_1.createSchema)(x => x.object({
    shape: {
        code: x.string(),
        type: x.object(),
        isActive: x.boolean(),
        configValues: x.object({
            shape: {
                price: x.number({
                    rounded: true,
                    positive: true,
                    withoutZero: true,
                }),
                isDefaultChecked: x.boolean(),
                title: x.object({
                    shape: locale_1.allLocales.reduce((acc, locale) => ({
                        ...acc,
                        [locale]: x.string(),
                    }), {}),
                }),
                description: x.object({
                    shape: locale_1.allLocales.reduce((acc, locale) => ({
                        ...acc,
                        [locale]: x.string(),
                    }), {}),
                }),
            },
        }),
    },
}));
const defaultValues = {
    isActive: true,
};
const mapTypeNameToFormattedMessage = (name) => {
    switch (name) {
        case 'passenger-fix-price':
            return (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/RateOptionEdit/Edit:PassengerFixPriceType', defaultMessage: 'Type with fixed price' }));
        case 'general':
            return (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/RateOptionEdit/Edit:GeneralType', defaultMessage: 'General' }));
        case 'travel-insurance':
            return (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/RateOptionEdit/Edit:TravelInsuranceType', defaultMessage: 'Travel insurance' }));
        default:
            return '';
    }
};
const RateOptionEdit = (props) => {
    var _a;
    const { typeFieldDisabled, onSubmit, } = props;
    const { field, fieldControlled, getError, createSubmit, } = (0, useForm_1.useAdvancedForm)({
        schema,
        defaultValues: (_a = props.defaultValues) !== null && _a !== void 0 ? _a : defaultValues,
    });
    const [activeLocale, setActiveLocale] = (0, react_1.useState)('en');
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement("div", { className: `${className}__container` },
            react_1.default.createElement("div", { className: (0, classFunctions_1.getClassNames)(`${className}__field`, 'full') },
                react_1.default.createElement(Field_1.FormField, { ...field('code', { dataType: 'string' }), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Rate/Option:Name', defaultMessage: 'Name' }) })),
            react_1.default.createElement("div", { className: `${className}__row` },
                react_1.default.createElement("div", { className: `${className}__field` },
                    react_1.default.createElement(Select_1.FormFieldSelect, { ...fieldControlled('type'), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/RateOptionEdit/Edit:Type', defaultMessage: 'Type' }), items: props.typeList, toItem: (value) => ({
                            label: mapTypeNameToFormattedMessage(value.name),
                            value: `${value.id}`,
                        }), disabled: typeFieldDisabled }))),
            react_1.default.createElement("div", { className: `${className}__config-values` },
                react_1.default.createElement("div", { className: `${className}__row` },
                    react_1.default.createElement("div", { className: `${className}__field` },
                        react_1.default.createElement(Field_1.FormField, { ...field('configValues.price', { dataType: 'number' }), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Rate/Option:price', defaultMessage: 'Price' }), addon: 'CHF' }))),
                react_1.default.createElement("div", { className: `${className}__row` },
                    react_1.default.createElement("div", { className: (0, classFunctions_1.getClassNames)(`${className}__field`, 'with-checkbox') },
                        react_1.default.createElement(CheckBox_1.CheckBox, { ...field('configValues.isDefaultChecked', { dataType: 'boolean' }), text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Rate/Option:isDefaultChecked', defaultMessage: 'Checked by default' }) }))),
                react_1.default.createElement("div", { className: (0, classFunctions_1.getClassNames)(`${className}__field`, 'full') },
                    react_1.default.createElement(Tabs_1.Tabs, { tabs: locale_1.allLocales.map(locale => ({
                            id: locale,
                            title: Multilanguage_1.localeLabels[locale],
                            content: (react_1.default.createElement(Field_1.FormField, { ...field(`configValues.title.${locale}`, { dataType: 'string' }), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Rate/Option:Title', defaultMessage: 'Title' }), modificators: 'top-padding' })),
                            hasError: !!getError(`configValues.title.${locale}`),
                        })), selectedId: activeLocale, select: setActiveLocale, modificators: 'languages' })),
                react_1.default.createElement("div", { className: (0, classFunctions_1.getClassNames)(`${className}__field`, 'full') },
                    react_1.default.createElement(Tabs_1.Tabs, { tabs: locale_1.allLocales.map(locale => ({
                            id: locale,
                            title: Multilanguage_1.localeLabels[locale],
                            content: (react_1.default.createElement(Textarea_1.FormFieldTextarea, { ...field(`configValues.description.${locale}`, { dataType: 'string' }), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Rate/Option:Description', defaultMessage: 'Description' }), modificators: 'top-padding' })),
                            hasError: !!getError(`configValues.description.${locale}`),
                        })), selectedId: activeLocale, select: setActiveLocale, modificators: 'languages' }))),
            react_1.default.createElement("div", { className: `${className}__row` },
                react_1.default.createElement("div", { className: (0, classFunctions_1.getClassNames)(`${className}__field`, 'with-checkbox') },
                    react_1.default.createElement(CheckBox_1.CheckBox, { ...field('isActive', { dataType: 'boolean' }), text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Rate/Option:Active', defaultMessage: 'Active' }) }))),
            react_1.default.createElement("div", { className: `${className}__button` },
                react_1.default.createElement(Button_1.Button, { icon: 'save', text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Rate/Option:Save', defaultMessage: 'Save' }), type: 'submit', onClick: createSubmit(onSubmit) })))));
};
exports.RateOptionEdit = RateOptionEdit;
//# sourceMappingURL=index.js.map